import { LinkTrackingProps, ButtonTrackingProps } from '@trustpilot/ecommscript-integrationappauth';

export const trackLink = (track: LinkTrackingProps) => {
    const { source, ...restTrack} = track!;
    analytics.track('Integration Link Clicked', {
        context: 'Ecommscript integration app',
        location: window.location.pathname,
        integration: source,
        ...restTrack
    });
};

export const trackButton = (track: ButtonTrackingProps) => {
    const { source, ...restTrack} = track;
    analytics.track('Integration Button Clicked', {
        context: 'Ecommscript integration app',
        location: window.location.pathname,
        integration: source,
        ...restTrack
    });
};



// WEBPACK FOOTER //
// ./src/Tracking.tsx